const { UserLevel } = require("utils/constant");

export const generateLevelUjiSilangOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.Fasyankes:
      return [{ label: "Fasyankes", value: UserLevel.Fasyankes }];
    case UserLevel.District:
      return [
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
    case UserLevel.LabTier2:
      return [{ label: "Kabupaten/Kota", value: UserLevel.LabTier2 }];
    case UserLevel.Province:
      return [
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
    case UserLevel.LabTier3:
      return [{ label: "Provinsi", value: UserLevel.LabTier3 }];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
  }
};

export const generateLevelOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.Fasyankes:
      return [{ label: "Fasyankes", value: UserLevel.Fasyankes }];
    case UserLevel.District:
      return [
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
    case UserLevel.Province:
      return [
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
  }
};

export const generateLevelCrosscheckKabOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.District:
      return [{ label: "Kabupaten/Kota", value: UserLevel.District }];
    case UserLevel.Province:
      return [
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
  }
};
export const generateLevelCrosscheckProvOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.Province:
      return [{ label: "Provinsi", value: UserLevel.Province }];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
      ];
  }
};

export const generateLevelKetenagaanOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.District:
      return [{ label: "Kabupaten/Kota", value: UserLevel.District }];
    case UserLevel.Province:
      return [
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
  }
};

export const generateLevelPMEOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.District:
      return [{ label: "Kabupaten/Kota", value: UserLevel.District }];
    case UserLevel.Province:
      return [
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
      ];
  }
};

export const generateLevelMMPOptions = (userLevel) => {
  switch (userLevel) {
    case UserLevel.Fasyankes:
      return [{ label: "Fasyankes", value: UserLevel.Fasyankes }];
    case UserLevel.District:
      return [
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
    case UserLevel.Province:
      return [
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
    default:
      return [
        { label: "Nasional", value: UserLevel.National },
        { label: "Provinsi", value: UserLevel.Province },
        { label: "Kabupaten/Kota", value: UserLevel.District },
        { label: "Fasyankes", value: UserLevel.Fasyankes },
      ];
  }
};

export const checkScoreInvalid = (value) => {
  if (value !== "" && value !== null && (value < 1 || value > 100)) {
    return true;
  }

  return false;
};

export const isValidRangeNumber = (v, start, end) => {
  if (v === "" || v === null || v === undefined) return false;
  const num = Number(v);
  return !Number.isNaN(num) && num >= start && num <= end;
};

export const maskNumber = (value) => {
  if (value === null || value === undefined) return "";
  const str = value.toString();
  if (str.length <= 8) return str;
  return str.slice(0, 4) + "*".repeat(str.length - 8) + str.slice(-4);
};

export const getInterpretasi = (hasilVerifikasi = "", parasyte = []) => {
  if (!hasilVerifikasi || !parasyte.length) return "";

  // Positif Benar: Faskes hasil pos, hasil verifikasi positif
  // Negatif Benar: Faskes hasil neg, hasil verifikasi negatif
  // Positif Palsu: Faskes hasil positif, hasil verifikasi negatif
  // Negatif Palsu: Faskes hasil negatif, hasil verifikasi positif

  hasilVerifikasi = hasilVerifikasi.toLowerCase();
  parasyte = parasyte.map((item) => item.toLowerCase());

  if (!hasilVerifikasi?.includes("negatif") && !parasyte?.includes("negatif")) {
    return "Positif Benar";
  } else if (
    hasilVerifikasi?.includes("negatif") &&
    parasyte?.includes("negatif")
  ) {
    return "Negatif Benar";
  } else if (
    hasilVerifikasi?.includes("negatif") &&
    !parasyte?.includes("negatif")
  ) {
    return "Positif Palsu";
  } else if (
    !hasilVerifikasi?.includes("negatif") &&
    parasyte?.includes("negatif")
  ) {
    return "Negatif Palsu";
  }
  return "";
};
